import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom'
import axios from "axios";
import Header from "./header";
import { getToken } from "../utils/token";

function SwatchesCard({ image_url, id }) {
    return (
        <div className='swatch-card-wrapper2'>
            <div className='swatch-card-container2'>
                <Link className='collection-link' to={`/swatch/detail/${id}`}>
                    <img alt="Swatch" src={image_url} />
                </Link>
            </div>
        </div>
    )
}

export default function Collections() {
    const [collectionUniqueCode, setCollectionUniqueCode] = useState("");
    const [customerUC, setCustomerUC] = useState("");
    const [username, setUsername] = useState("");
    const [description, setDescription] = useState("");
    const [collection, setCollection] = useState([]);
    const [clientName, setClientName] = useState("")
    // eslint-disable-next-line no-unused-vars
    let lat = "";
    let long = "";
    let lang = "";

    useEffect(() => {
        console.log(window.location.search)
        localStorage.setItem("backQueryString", window.location.search);
        fecthCollection();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const fecthCollection = async () => {
        let urlParams = new URLSearchParams(window.location.search);
        console.log(urlParams.get("cuc"));
        setCollectionUniqueCode(urlParams.get("coll_uc"))
        setCustomerUC(urlParams.get("cuc"))
        setUsername(urlParams.get("un"))
        console.log(collectionUniqueCode, customerUC, username);
        lat = urlParams.get("un");
        long = urlParams.get("cuc");
        lang = urlParams.get("coll_uc");
        const token = getToken()
        let url;
        try {
            if (token){
                url= `https://amal.platform.simplifii.com/api/v1/custom/swatches?token=${token}&coll_uc=${lang}`
            }
            else{
                url= `https://amal.platform.simplifii.com/api/v1/custom/swatches?un=${lat}&cuc=${long}&coll_uc=${lang}`
            }
            let response = await axios.get(url);

            console.log(response)
            setDescription(response.data.collection_description);
            setCollection(response.data.response.data || []);
            setClientName(response.data.client || "") 
            localStorage.setItem('collection', JSON.stringify(response.data.response.data || []));
            localStorage.setItem('clientName', response.data.client);

        } catch (e) {
            if (e && e["message"]) {
                alert(e["message"]);
            }
        }
    };

    return (
        <>
        <Header clientName={clientName} />
        <div className='collection-container'>
            <div className='collection-code-container'>
                <div>
                    <strong className='collection-code'>Collection Code: {collectionUniqueCode}</strong>
                    <p>{description}</p>
                </div>
            </div>
            <section style={{padding: 0}} className="gallery">
                <div>
                    {
                        collection.map((image, index) => <SwatchesCard id={image.swatch_unique_code} key={image.swatch_unique_code} image_url={image.primary_image_thumbnail} />)
                    }
                </div>
            </section>
        </div>
        </>
    )
}
